import {createContext} from 'react'
import {LayoutDimension, NetworkStatus, WindowModeType} from 'types/commons'
import {getWindowMode} from 'utils/commons'

export const WindowLayoutContext = createContext<LayoutDimension>({
  width: window.innerWidth,
  height: window.innerHeight,
})

export const WindowNetworkStatusContext = createContext<NetworkStatus>(
  navigator.onLine ? 'online' : 'offline',
)

export const WindowModeContext = createContext<WindowModeType>(getWindowMode())
